import React from 'react';
import classNames from 'classnames';
import { string } from 'prop-types';

import css from './PrimaryEventImage.module.css';

/**
 * Images inside the standard listing-card aspect box:
 * sharp image scaled to fit (contain), letterbox filled with a blurred copy of the same image.
 */
const PrimaryEventImage = props => {
  const { className, rootClassName, src, srcSet, alt, sizes, loading } = props;
  // Always keep `.frame` layout; `rootClassName` alone used to replace it and broke TN cards.
  const classes = classNames(css.frame, rootClassName, className);

  const foregroundProps = {
    className: css.foreground,
    src,
    alt,
    sizes,
    loading,
  };
  if (srcSet) {
    foregroundProps.srcSet = srcSet;
  }

  return (
    <div className={classes}>
      <img className={css.background} src={src} alt="" aria-hidden loading={loading} />
      <img {...foregroundProps} />
    </div>
  );
};

PrimaryEventImage.defaultProps = {
  className: null,
  rootClassName: null,
  sizes: null,
  loading: 'lazy',
};

PrimaryEventImage.propTypes = {
  className: string,
  rootClassName: string,
  src: string.isRequired,
  srcSet: string,
  alt: string.isRequired,
  sizes: string,
  loading: string,
};

export default PrimaryEventImage;
